import React, {useEffect, useState} from "react";
import "./AddClient.css";
import {Bounce, toast} from "react-toastify";
import {useRegisterClient} from "../../hooks/Administrative/useRegisterClient";

const AddClient = ({onHandleBack, addClientLocally}: { onHandleBack: () => void, addClientLocally: (newClientDTO: any) => void }) => {
    const [clientName, setClientName] = useState("");
    const [email, setEmail] = useState("");
    const [mainPhone, setMainPhone] = useState("");
    const [secondaryPhone, setSecondaryPhone] = useState("");
    const [taxAddress, setTaxAddress] = useState("");
    const [uniqueCode, setUniqueCode] = useState("");
    const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);

    const {registerClient, loading} = useRegisterClient();

    const validateFullName = (fullName: string) => {
        const fullNameRegex = /^.{1,80}$/; // Allows any character but limits length
        return fullNameRegex.test(fullName);
    };

    const validateAddress = (fullName: string) => {
        const fullNameRegex = /^.{1,200}$/;
        return fullNameRegex.test(fullName);
    };

    const validateEmail = (email: string) => {
        const emailRegex = /^[^\s@]{1,64}@[^\s@]{1,186}\.[^\s@]+$/;
        return email.length <= 250 && emailRegex.test(email);
    };

    const validatePhone = (phone: any) => {
        const phoneRegex = /^[+]?[0-9]{10,15}$/;
        return phoneRegex.test(phone);
    };

    const validateUniqueCode = (uniqueCode: string) => {
        const regex = /^[a-zA-Z0-9_]{5,50}$/;
        return regex.test(uniqueCode);
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!validateFullName(clientName)) {
            toast.error("El nombre del cliente no puede exceder los 80 caracteres.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        if (mainPhone && !validatePhone(mainPhone)) {
            toast.error("El teléfono principal no es válido. Por favor, ingrese un número válido.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        if (secondaryPhone && !validatePhone(secondaryPhone)) {
            toast.error("El teléfono secundario no es válido. Por favor, ingrese un número válido.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        if (!validateUniqueCode(uniqueCode)) {
            toast.error("El código único solo puede contener letras, números y guión bajo (_). Tiene que tener entre 5 y 10 caracteres.", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        const newClient = {
            email: email.trim() === "" ? null : email.trim(),
            name: clientName,
            mainPhone: mainPhone,
            secondaryPhone: secondaryPhone,
            taxAddress: taxAddress,
            uniqueCode: uniqueCode
        }

        registerClient(newClient).then((response:any) => {
            toast.success('¡Cliente creado correctamente!', {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            resetForm()
            addClientLocally(response)
        }).catch((err) => {
            toast.error(err, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
        });
    };

    const resetForm = () => {
        setClientName("");
        setEmail("");
        setMainPhone("");
        setSecondaryPhone("");
        setTaxAddress("");
        setUniqueCode("");
    };

    useEffect(() => {
        const isDisabled = !clientName || !uniqueCode;
        setIsConfirmDisabled(isDisabled);
    }, [clientName, uniqueCode]);

    return (
        <div className="add-client-container">
            {(loading) && <div className="loading-overlay">
                <div className="spinner">
                </div>
                <div className="loading-message">
                    {loading ? 'Guardando cliente' : 'Obteniendo información'}
                </div>
            </div>
            }
            <div className="add-client-view-header">
                <button onClick={onHandleBack}>REGRESAR</button>
                <span className="material-icons user" aria-label="edit ticket">
                            work
                        </span>
                <div className="add-client-view-header-title">
                    <p>AÑADIR CLIENTE</p>
                </div>
            </div>
            <form className="add-client-form" onSubmit={handleSubmit}>
                <div className="form-item">
                    <label htmlFor="name">NOMBRE *</label>
                    <input
                        id="name"
                        value={clientName}
                        onChange={(e) => setClientName(e.target.value)}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="email">EMAIL *</label>
                    <input
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="mainPhone">TELÉFONO PRINCIPAL</label>
                    <input
                        id="mainPhone"
                        value={mainPhone}
                        onChange={(e) => setMainPhone(e.target.value)}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="secondaryPhone">TELÉFONO SECUNDARIO</label>
                    <input
                        id="secondaryPhone"
                        value={secondaryPhone}
                        onChange={(e) => setSecondaryPhone(e.target.value)}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="taxAddress">DIRECCIÓN FISCAL</label>
                    <input
                        id="taxAddress"
                        value={taxAddress}
                        onChange={(e) => setTaxAddress(e.target.value)}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="uniqueCode">CÓDIGO ÚNICO *</label>
                    <input
                        id="uniqueCode"
                        value={uniqueCode}
                        onChange={(e) => setUniqueCode(e.target.value)}
                    />
                </div>

                <div className="bottom">
                    <p>* Campos obligatorios</p>
                    <div className="buttons">
                        <button type="button" className="cancel" onClick={resetForm}>
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className={`confirm ${isConfirmDisabled ? 'disabled' : ''}`}
                            disabled={isConfirmDisabled}
                        >
                            Confirmar
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddClient;
